<template>
  <div class="modal topup-modal sale-skin-modal offer-modal">
    <div class="overlay" @click="$emit('closeOfferDetailsModal')"></div>
    <div class="wrapper">
      <div class="container">
        <form class="form" @submit.prevent>
          <div class="form-wrapper">
            <img
              class="close"
              @click="$emit('closeOfferDetailsModal')"
              src="./../images/close.svg"
            />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="cart-up">
                  <div class="cart-top">
                    <div class="desc">
                      <b>DETAILS</b>
                    </div>
                  </div>
                  <div class="offer-wrapper topup-form">
                    <div class="row">
                      <div class="title">Skin name</div>
                      <div class="desc">{{ orderToView.title }}</div>
                    </div>
                    <div class="row">
                      <div class="title">Quality</div>
                      <div class="desc">{{ orderToView.quality }}</div>
                    </div>
                    <div class="row">
                      <div class="title">Desired Price</div>
                      <div class="desc">
                        <b>
                          {{ orderToView.user_price }}
                          {{ orderToView.currency }}</b
                        >
                      </div>
                    </div>
                    <div class="row our-price">
                      <div class="title">Our price</div>
                      <div class="desc">
                        <b>
                          <template v-if="orderToView.service_price">
                            {{ orderToView.service_price }} {{ orderToView.currency }}
                          </template>
                          <template v-else>
                            <span class="desc gray">No offer yet</span>
                          </template>
                        </b>
                      </div>
                    </div>
                    <transition name="slide">
                      <div v-if="error" class="error-desc desc red">
                        {{ error }}
                      </div>
                    </transition>
                    <div class="buttons" v-if="orderToView.status === 'offer'">
                      <div
                        class="button"
                        @click="decline"
                        :disabled="isLoading"
                      >
                        <span>{{ isLoading ? "Processing..." : "Decline" }}</span>
                      </div>
                      <div
                        class="button red"
                        @click="accept"
                        :disabled="isLoading"
                      >
                        <span>{{ isLoading ? "Accepting..." : "Accept" }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OfferDetailsModal",
  props: ["orderToView"],
  data() {
    return {
      isLoading: false,
      error: "",
    };
  },
  methods: {
    formatStatus(status) {
      if (!status) return "";
      return status.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    },
    handleApiCall(endpoint, successMessage) {
      if (this.isLoading) return;
      this.isLoading = true;
      this.error = "";

      const data = { id: this.orderToView.id };

      this.$http
        .post(process.env.VUE_APP_API + endpoint, data)
        .then(() => {
          console.log(successMessage);
          this.$emit("actionCompleted");
          this.$emit("closeOfferDetailsModal");
        })
        .catch((err) => {
          this.error =
            err.response?.data?.message || "An unexpected error occurred.";
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    decline() {
      this.handleApiCall("offer/decline", "Offer declined successfully.");
    },
    accept() {
      this.handleApiCall("offer/accept", "Offer accepted successfully.");
    },
  },
  watch: {
    orderToView() {
      this.error = "";
    },
  },
};
</script>

<style scoped>
.offer-modal .form-fields-wrapper .our-price {
    padding: 16px;
    border-radius: 6px;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(67, 73, 86);
    border-image: initial;
}
</style>